import { useMutation } from '@tanstack/react-query';

import { FileParameter, ReportType, AttachmentClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const attachmentClient = new AttachmentClient(apiBaseUrl);

export interface IAttachmentMutationVariables {
  reportId: number, fileName: string | null | undefined;
  reportType: ReportType;
  size: number | null | undefined;
  formFile: FileParameter | null | undefined;
}

function useAddAttachment() {
  return useMutation({
    mutationKey: [queryKeys.Attachment.Add],
    mutationFn: ({
      reportId,
      reportType,
      fileName,
      size,
      formFile,
    }: IAttachmentMutationVariables) => attachmentClient.addAttachmentToEventReport(
      reportId,
      reportType,
      null,
      fileName,
      undefined,
      size,
      formFile,
    ),
  });
}

export default useAddAttachment;
